import {PlayersStatisticsTableColumnDomainModel} from "./players-statistics.table.column.domain-model";
import {BaseViewModel} from "../../../../../../infrastructure/models/base-view-model";

export class PlayersStatisticsTableColumnViewModel extends BaseViewModel {
  domainModel: PlayersStatisticsTableColumnDomainModel;

  get num(): Number {
    return this.domainModel.num;
  }

  get shortName(): String {
    return this.domainModel.shortName;
  }

  get order(): Number {
    return this.domainModel.order;
  }

  get isMajor(): Boolean {
    return this.domainModel.isMajor;
  }

  get isGraphic(): Boolean {
    return this.domainModel.isGraphic;
  }

  get columnGroup(): Boolean {
    return this.domainModel.columnGroup;
  }
}
